"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestoreButtonLabel = exports.RestoreButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = _interopRequireDefault(require("../../Box"));
var _templateObject, _templateObject2;
const RestoreButton = exports.RestoreButton = (0, _styledComponents["default"])(_Box["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
const RestoreButtonLabel = exports.RestoreButtonLabel = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  text-decoration: underline;\n  color: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.feedback.danger.normal;
});